import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
} from '@angular/forms';

/**
 * Check that there are no duplicate team assignations in the FormArray
 * @returns 
 */
export function hasDuplicateTeamAssignationValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as FormArray;
    const enabledTeamIds = formArray.controls
      .filter((ctrl) => ctrl.get('team_id')?.enabled)
      .map((ctrl) => ctrl.get('team_id')?.value);

    const uniqueTeamIds = new Set(enabledTeamIds);
    return enabledTeamIds.length !== uniqueTeamIds.size ? { duplicateTeam: true } : null;
  };
}

export function startDateAfterHiringDateValidator(hiringDate: string | undefined): ValidatorFn {

    
  return (control: AbstractControl): ValidationErrors | null => {

    const startDate = control.value;

    if (!startDate || !hiringDate) {
      return null;
    }

    const startDateObj = new Date(startDate);
    const hiringDateObj = new Date(hiringDate);


    if (startDateObj < hiringDateObj) {
      return { 'startDateBeforeHiringDate': true };
    }

    return null;
  };
}